export function AddImageSvg({ ...props }) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
            <path
                d="M19 10a1 1 0 0 0-1 1v3.38l-1.48-1.48a2.79 2.79 0 0 0-3.93 0l-.7.71l-2.48-2.49a2.79 2.79 0 0 0-3.93 0L4 12.61V7a1 1 0 0 1 1-1h8a1 1 0 0 0 0-2H5a3 3 0 0 0-3 3v12.22A2.79 2.79 0 0 0 4.78 22h12.44a2.88 2.88 0 0 0 .8-.12a2.74 2.74 0 0 0 2-2.65V11A1 1 0 0 0 19 10zM5 20a1 1 0 0 1-1-1v-3.57l2.89-2.89a.78.78 0 0 1 1.1 0L15.46 20zm13-1a1 1 0 0 1-.18.54L13.3 15l.71-.7a.77.77 0 0 1 1.1 0L18 17.21zm3-15h-1V3a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2h1v1a1 1 0 0 0 2 0V6h1a1 1 0 0 0 0-2z"
                fill={props.color}
            ></path>
        </svg>
    );
}

export function AddPostSvg({ ...props }) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
            <path
                d="M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-8-2h2v-4h4v-2h-4V7h-2v4H7v2h4z"
                fill={props.color}
            ></path>
        </svg>
    );
}

export function ExploreSvg({ ...props }) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
            <path
                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10s10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8s8 3.59 8 8s-3.59 8-8 8zm-5.5-2.5l7.51-3.49L17.5 6.5L9.99 9.99L6.5 17.5zm5.5-6.6c.61 0 1.1.49 1.1 1.1s-.49 1.1-1.1 1.1s-1.1-.49-1.1-1.1s.49-1.1 1.1-1.1z"
                fill={props.color}
            ></path>
        </svg>
    );
}

export function HomeSvg({ ...props }) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
            <path
                d="M20 20V9.132l-8-4.8l-8 4.8V20h4v-2.75a4 4 0 1 1 8 0V20h4zm-6 2v-4.75a2 2 0 1 0-4 0V22H4a2 2 0 0 1-2-2V9.132a2 2 0 0 1 .971-1.715l8-4.8a2 2 0 0 1 2.058 0l8 4.8A2 2 0 0 1 22 9.132V20a2 2 0 0 1-2 2h-6z"
                fill={props.color}
            ></path>
        </svg>
    );
}

export function SettingsSvg({ ...props }) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
            <g fill="none">
                <path
                    d="M13.82 22h-3.64a1 1 0 0 1-.977-.786l-.407-1.884a8.002 8.002 0 0 1-1.535-.887l-1.837.585a1 1 0 0 1-1.17-.453L2.43 15.424a1.006 1.006 0 0 1 .193-1.239l1.425-1.3a8.1 8.1 0 0 1 0-1.772L2.623 9.816a1.006 1.006 0 0 1-.193-1.24l1.82-3.153a1 1 0 0 1 1.17-.453l1.837.585c.244-.18.498-.348.76-.5c.253-.142.513-.271.779-.386l.408-1.882A1 1 0 0 1 10.18 2h3.64a1 1 0 0 1 .976.787l.412 1.883a7.993 7.993 0 0 1 1.534.887l1.838-.585a1 1 0 0 1 1.169.453l1.82 3.153c.232.407.152.922-.193 1.239l-1.425 1.3a8.1 8.1 0 0 1 0 1.772l1.425 1.3c.345.318.425.832.193 1.239l-1.82 3.153a1 1 0 0 1-1.17.453l-1.837-.585a7.98 7.98 0 0 1-1.534.886l-.412 1.879a1 1 0 0 1-.976.786zm-6.2-5.771l.82.6c.185.136.377.261.577.375c.188.109.38.207.579.296l.933.409l.457 2.091h2.03l.457-2.092l.933-.409c.407-.18.794-.403 1.153-.666l.82-.6l2.042.65l1.015-1.758l-1.583-1.443l.112-1.012c.05-.443.05-.89 0-1.332l-.112-1.012l1.584-1.446l-1.016-1.759l-2.041.65l-.821-.6a6.227 6.227 0 0 0-1.153-.671l-.933-.409L13.016 4h-2.03l-.46 2.092l-.93.408a6.01 6.01 0 0 0-1.153.666l-.821.6l-2.04-.65L4.565 8.88l1.583 1.441l-.112 1.013c-.05.443-.05.89 0 1.332l.112 1.012l-1.583 1.443l1.015 1.758l2.04-.65zM11.996 16a4 4 0 1 1 0-8a4 4 0 0 1 0 8zm0-6a2 2 0 1 0 2 2.09v.4V12a2 2 0 0 0-2-2z"
                    fill={props.color}
                ></path>
            </g>
        </svg>
    );
}

export function MoreSvg({ ...props }) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
            <path
                d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2s-2 .9-2 2s.9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2z"
                fill={props.color}
            ></path>
        </svg>
    );
}

export function DeleteSvg({ ...props }) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
            <path
                d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v10zM18 4h-2.5l-.71-.71c-.18-.18-.44-.29-.7-.29H9.91c-.26 0-.52.11-.7.29L8.5 4H6c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1z"
                fill={props.color}
            ></path>
        </svg>
    );
}

export function NotificationSvg({ ...props }) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
            <path
                d="M19.29 17.29L18 16v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-1.29 1.29c-.63.63-.19 1.71.7 1.71h13.17c.9 0 1.34-1.08.71-1.71zM16 17H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6zm-4 5c1.1 0 2-.9 2-2h-4a2 2 0 0 0 2 2z"
                fill={props.color}
            ></path>
        </svg>
    );
}

export function ProfileSvg({ ...props }) {
    return (
        <svg width="0.9em" height="1em" viewBox="0 0 344 384" {...props}>
            <path
                d="M170.5 62Q152 62 139 75t-13 31.5t13 31.5t31.5 13t31.5-13t13-31.5T202 75t-31.5-13zm.5 192q-44 0-87 16.5T41 299v23h260v-23q0-12-43-28.5T171 254zm-.5-233Q206 21 231 46t25 60.5t-25 60.5t-60.5 25t-60.5-25t-25-60.5T110 46t60.5-25zm0 192q31.5 0 69.5 9t69.5 29.5T341 299v64H0v-64q0-27 31.5-47.5T101 222t69.5-9z"
                fill={props.color}
            ></path>
        </svg>
    );
}

export function LikeSvg({ ...props }) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 48 48" {...props}>
            <path
                d="M15 8C8.925 8 4 12.925 4 19c0 11 13 21 20 23.326C31 40 44 30 44 19c0-6.075-4.925-11-11-11c-3.72 0-7.01 1.847-9 4.674A10.987 10.987 0 0 0 15 8z"
                stroke={props.color}
                strokeWidth={props.strokeWidth || "4"}
                strokeLinecap="round"
                strokeLinejoin="round"
                fill={props.fill}
            ></path>
        </svg>
    );
}

export function EditSvg({ ...props }) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
            <path
                d="M3 17.46v3.04c0 .28.22.5.5.5h3.04c.13 0 .26-.05.35-.15L17.81 9.94l-3.75-3.75L3.15 17.1c-.1.1-.15.22-.15.36zM20.71 7.04a.996.996 0 0 0 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83l3.75 3.75l1.83-1.83z"
                fill={props.color}
            ></path>
        </svg>
    );
}

export function BookmarkSvg({ ...props }) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
            <path
                d="M17 3H7c-1.1 0-2 .9-2 2v16l7-3l7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V6c0-.55.45-1 1-1h8c.55 0 1 .45 1 1v12z"
                fill="currentColor"
            ></path>
        </svg>
    );
}

export function BookmarkFilledSvg({ ...props }) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
            <path
                d="M17 3H7c-1.1 0-2 .9-2 2v16l7-3l7 3V5c0-1.1-.9-2-2-2z"
                fill="#3b82f6"
            ></path>
        </svg>
    );
}

export function PostSvg({ ...props }) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
            <path
                d="M20 16V4H8v12h12m2 0a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V4c0-1.11.89-2 2-2h12a2 2 0 0 1 2 2v12m-6 4v2H4a2 2 0 0 1-2-2V7h2v13h12z"
                fill={props.color}
            ></path>
        </svg>
    );
}

export function CommentSvg({ ...props }) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
            <path
                d="M256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 368c-26.7 0-53.1-4.1-78.4-12.1l-22.7-7.2l-19.5 13.8c-14.3 10.1-33.9 21.4-57.5 29c7.3-12.1 14.4-25.7 19.9-40.2l10.6-28.1l-20.6-21.8C69.7 314.1 48 282.2 48 240c0-88.2 93.3-160 208-160s208 71.8 208 160s-93.3 160-208 160z"
                fill={props.color}
            ></path>
        </svg>
    );
}

export function ShareSvg({ ...props }) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
            <path
                d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81c1.66 0 3-1.34 3-3s-1.34-3-3-3s-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65c0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z"
                fill={props.color}
            ></path>
        </svg>
    );
}

export function CloseSvg({ ...props }) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
            <path
                d="M12 2c5.53 0 10 4.47 10 10s-4.47 10-10 10S2 17.53 2 12S6.47 2 12 2m3.59 5L12 10.59L8.41 7L7 8.41L10.59 12L7 15.59L8.41 17L12 13.41L15.59 17L17 15.59L13.41 12L17 8.41L15.59 7z"
                fill={props.color}
            ></path>
        </svg>
    );
}

export function LoaderSvg() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="90px"
            height="90px"
            viewBox="0 0 100 100"
            preserveAspectRatio="xMidYMid"
        >
            <g transform="translate(80,50)">
                <g transform="rotate(0)">
                    <circle cx="0" cy="0" r="6" fill="#ff727d" fillOpacity="1">
                        <animateTransform
                            attributeName="transform"
                            type="scale"
                            begin="-0.875s"
                            values="1.5 1.5;1 1"
                            keyTimes="0;1"
                            dur="1s"
                            repeatCount="indefinite"
                        ></animateTransform>
                        <animate
                            attributeName="fillOpacity"
                            keyTimes="0;1"
                            dur="1s"
                            repeatCount="indefinite"
                            values="1;0"
                            begin="-0.875s"
                        ></animate>
                    </circle>
                </g>
            </g>
            <g transform="translate(71.21320343559643,71.21320343559643)">
                <g transform="rotate(45)">
                    <circle
                        cx="0"
                        cy="0"
                        r="6"
                        fill="#ff727d"
                        fillOpacity="0.875"
                    >
                        <animateTransform
                            attributeName="transform"
                            type="scale"
                            begin="-0.75s"
                            values="1.5 1.5;1 1"
                            keyTimes="0;1"
                            dur="1s"
                            repeatCount="indefinite"
                        ></animateTransform>
                        <animate
                            attributeName="fillOpacity"
                            keyTimes="0;1"
                            dur="1s"
                            repeatCount="indefinite"
                            values="1;0"
                            begin="-0.75s"
                        ></animate>
                    </circle>
                </g>
            </g>
            <g transform="translate(50,80)">
                <g transform="rotate(90)">
                    <circle
                        cx="0"
                        cy="0"
                        r="6"
                        fill="#ff727d"
                        fillOpacity="0.75"
                    >
                        <animateTransform
                            attributeName="transform"
                            type="scale"
                            begin="-0.625s"
                            values="1.5 1.5;1 1"
                            keyTimes="0;1"
                            dur="1s"
                            repeatCount="indefinite"
                        ></animateTransform>
                        <animate
                            attributeName="fillOpacity"
                            keyTimes="0;1"
                            dur="1s"
                            repeatCount="indefinite"
                            values="1;0"
                            begin="-0.625s"
                        ></animate>
                    </circle>
                </g>
            </g>
            <g transform="translate(28.786796564403577,71.21320343559643)">
                <g transform="rotate(135)">
                    <circle
                        cx="0"
                        cy="0"
                        r="6"
                        fill="#ff727d"
                        fillOpacity="0.625"
                    >
                        <animateTransform
                            attributeName="transform"
                            type="scale"
                            begin="-0.5s"
                            values="1.5 1.5;1 1"
                            keyTimes="0;1"
                            dur="1s"
                            repeatCount="indefinite"
                        ></animateTransform>
                        <animate
                            attributeName="fillOpacity"
                            keyTimes="0;1"
                            dur="1s"
                            repeatCount="indefinite"
                            values="1;0"
                            begin="-0.5s"
                        ></animate>
                    </circle>
                </g>
            </g>
            <g transform="translate(20,50.00000000000001)">
                <g transform="rotate(180)">
                    <circle
                        cx="0"
                        cy="0"
                        r="6"
                        fill="#ff727d"
                        fillOpacity="0.5"
                    >
                        <animateTransform
                            attributeName="transform"
                            type="scale"
                            begin="-0.375s"
                            values="1.5 1.5;1 1"
                            keyTimes="0;1"
                            dur="1s"
                            repeatCount="indefinite"
                        ></animateTransform>
                        <animate
                            attributeName="fillOpacity"
                            keyTimes="0;1"
                            dur="1s"
                            repeatCount="indefinite"
                            values="1;0"
                            begin="-0.375s"
                        ></animate>
                    </circle>
                </g>
            </g>
            <g transform="translate(28.78679656440357,28.786796564403577)">
                <g transform="rotate(225)">
                    <circle
                        cx="0"
                        cy="0"
                        r="6"
                        fill="#ff727d"
                        fillOpacity="0.375"
                    >
                        <animateTransform
                            attributeName="transform"
                            type="scale"
                            begin="-0.25s"
                            values="1.5 1.5;1 1"
                            keyTimes="0;1"
                            dur="1s"
                            repeatCount="indefinite"
                        ></animateTransform>
                        <animate
                            attributeName="fillOpacity"
                            keyTimes="0;1"
                            dur="1s"
                            repeatCount="indefinite"
                            values="1;0"
                            begin="-0.25s"
                        ></animate>
                    </circle>
                </g>
            </g>
            <g transform="translate(49.99999999999999,20)">
                <g transform="rotate(270)">
                    <circle
                        cx="0"
                        cy="0"
                        r="6"
                        fill="#ff727d"
                        fillOpacity="0.25"
                    >
                        <animateTransform
                            attributeName="transform"
                            type="scale"
                            begin="-0.125s"
                            values="1.5 1.5;1 1"
                            keyTimes="0;1"
                            dur="1s"
                            repeatCount="indefinite"
                        ></animateTransform>
                        <animate
                            attributeName="fillOpacity"
                            keyTimes="0;1"
                            dur="1s"
                            repeatCount="indefinite"
                            values="1;0"
                            begin="-0.125s"
                        ></animate>
                    </circle>
                </g>
            </g>
            <g transform="translate(71.21320343559643,28.78679656440357)">
                <g transform="rotate(315)">
                    <circle
                        cx="0"
                        cy="0"
                        r="6"
                        fill="#ff727d"
                        fillOpacity="0.125"
                    >
                        <animateTransform
                            attributeName="transform"
                            type="scale"
                            begin="0s"
                            values="1.5 1.5;1 1"
                            keyTimes="0;1"
                            dur="1s"
                            repeatCount="indefinite"
                        ></animateTransform>
                        <animate
                            attributeName="fillOpacity"
                            keyTimes="0;1"
                            dur="1s"
                            repeatCount="indefinite"
                            values="1;0"
                            begin="0s"
                        ></animate>
                    </circle>
                </g>
            </g>
        </svg>
    );
}

export function EmptyPageSvg({ ...props }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props.width || "auto"}
            height={props.height}
            viewBox="0 0 503 488"
            fill="none"
        >
            <path
                d="M131.29 112.06C135.63 106.93 141.96 101.25 148.17 103.82C152.98 105.82 154.68 112.07 153.44 117.12C152.31 121.69 149.44 125.55 146.71 129.41C164.28 130.17 181.79 130.52 199.13 130.33C202.13 115.47 205.92 101.19 208.88 86.3301L3.04004 116.44C40.81 121.06 79.5 125.28 118.13 127.84C122.53 122.59 126.87 117.29 131.29 112.06Z"
                fill="#743C7A"
            />
            <path
                d="M206.32 43.4002C203.69 41.4902 200.95 39.5702 197.79 38.8602L189 41.5103L187 30.7703C187 30.7703 164 15.3703 160.56 13.0003C157.12 10.6303 153.56 8.28025 149.42 8.00025C144.12 7.63025 139.29 10.8003 134.95 13.8503C90.19 45.2703 3.04004 116.44 3.04004 116.44C87.04 112.28 168.26 88.3503 252.68 81.3203C237.987 67.778 222.507 55.1159 206.32 43.4002V43.4002Z"
                stroke="#47104E"
                strokeWidth="5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M186.96 30.7995C186.96 30.7995 163.96 15.3995 160.52 13.0295C157.08 10.6595 153.52 8.30955 149.38 8.02955C144.08 7.65955 139.25 10.8295 134.91 13.8795C90.19 45.2695 3.04004 116.44 3.04004 116.44C3.04004 116.44 142.37 58.3595 189.04 41.5395L186.96 30.7995Z"
                fill="#B786BB"
            />
            <path
                d="M206.32 43.4004C203.69 41.4904 200.95 39.5704 197.79 38.8604L189 41.5104C142.37 58.3304 3 116.41 3 116.41C87 112.25 168.22 88.3204 252.64 81.2904C237.959 67.7596 222.492 55.1076 206.32 43.4004Z"
                fill="#B786BB"
            />
            <path
                d="M386.45 145.83L391.06 136.61"
                stroke="#47104E"
                strokeWidth="5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M399.32 147.39L403.92 139.19"
                stroke="#47104E"
                strokeWidth="5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M386.09 168.04C390.742 169.726 395.813 169.877 400.557 168.469C405.302 167.062 409.47 164.171 412.45 160.22"
                stroke="#47104E"
                strokeWidth="5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M140.69 145.02C140.2 139.84 142.89 134.92 145.85 130.64C148.81 126.36 152.19 122.17 153.44 117.12C154.69 112.07 152.98 105.8 148.17 103.82C141.96 101.25 135.63 106.93 131.29 112.06C123.8 120.92 116.58 130 108.82 138.63C89.5698 160.05 76.6498 188.92 67.6398 215.83C56.0198 250.57 51.1998 286.97 61.4498 322.64C70.6498 354.64 101.71 374.81 132.37 371.64C162.3 368.5 185.45 354.13 219.87 323.16C200.45 366.65 170.6 440.99 151.21 484.51H457.33C458.76 484.51 459.56 483.98 460.99 483.94C468.64 483.75 475.57 478.82 479.99 472.55C484.41 466.28 486.63 458.8 488.52 451.38C499.87 406.91 501.01 360.46 499.2 314.6C498.55 298.14 497.2 280.76 487.84 267.21C478.84 254.29 459.84 245.45 426.35 235.58C435.35 211.389 442.701 186.616 448.35 161.43C449.94 154.31 451.35 146.76 449.06 139.85C446.62 132.62 440.38 127.26 433.6 123.77C419.6 116.58 402.95 116.08 387.66 119.64C372.37 123.2 358.24 130.54 344.66 138.48C351.3 143.48 367.12 148.91 367.12 148.91L341.83 218.72C331.83 217.8 323.36 217.4 316.63 217.24C307.169 217.12 297.712 217.712 288.34 219.01C255.17 223.25 234.2 228.94 207.85 240.34C181.5 251.74 138.69 284.51 138.69 284.51C132.48 262.51 138.5 228.92 149.98 203.51C155.62 191.04 165.53 173.66 168.98 160.43C171.55 150.63 171.71 139.82 168.29 130.43"
                stroke="#47104E"
                strokeWidth="5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M89.57 160.05C86.65 159.43 85.35 157.79 84.07 155.05C83.3825 153.559 83.0792 151.919 83.1874 150.281C83.2957 148.643 83.8123 147.057 84.69 145.67C87.37 141.51 92.69 140.04 97.46 138.9L110.84 135.73C110.84 135.73 102.21 136.2 97.9 136.83C93.59 137.46 88.79 137.36 85.46 134.58C83 132.53 83.76 130.19 84.22 127.05"
                stroke="#47104E"
                strokeWidth="5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M118.13 127.85C79.5 125.29 40.81 121.06 3.04004 116.44"
                stroke="#47104E"
                strokeWidth="5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M208.88 86.3301C205.88 101.19 202.09 115.47 199.13 130.33C181.78 130.52 164.28 130.18 146.71 129.42"
                stroke="#47104E"
                strokeWidth="5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M206.32 43.4002C203.69 41.4902 200.95 39.5702 197.79 38.8602L189 41.5103L187 30.7703C187 30.7703 164 15.3703 160.56 13.0003C157.12 10.6303 153.56 8.28025 149.42 8.00025C144.12 7.63025 139.29 10.8003 134.95 13.8503C90.19 45.2703 3.04004 116.44 3.04004 116.44C87.04 112.28 168.26 88.3503 252.68 81.3203C237.987 67.778 222.507 55.1159 206.32 43.4002V43.4002Z"
                stroke="#47104E"
                strokeWidth="5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M189 41.5098C142.37 58.3298 3 116.41 3 116.41"
                stroke="#47104E"
                strokeWidth="5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M222.54 105.93L268.54 100.42"
                stroke="#47104E"
                strokeWidth="5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M233.93 46.42L327.45 22.21"
                stroke="#47104E"
                strokeWidth="5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M192.69 18.73C208.39 13.12 240.87 3 240.87 3"
                stroke="#47104E"
                strokeWidth="5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M200.89 484.51C210.51 468.92 224.05 456.51 241.34 450.51C258.63 444.51 292.89 438.33 311.09 436.23C347.31 432.07 367.54 428.77 403.57 423.14C405.95 422.77 408.43 422.35 410.38 420.93C413.18 418.87 414.21 415.23 415.06 411.87C419.47 394.57 420.06 378.06 421.28 360.25"
                stroke="#47104E"
                strokeWidth="5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M210.65 484.51C219.32 473.91 234.02 462.79 247.15 458.9"
                stroke="#47104E"
                strokeWidth="5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M229.51 483.609C237.03 475.669 246.94 469.13 257.51 466.27"
                stroke="#47104E"
                strokeWidth="5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <style id="stylus-37" type="text/css" className="stylus">
                @import
                url('https://fonts.googleapis.com/css2?family=Fira+Code:wght@300;400;500;600;700&amp;display=swap');
            </style>
        </svg>
    );
}

export function HeroImageSvg({ ...props }) {
    return (
        <svg
            className="hero-image-styles"
            viewBox="0 0 519 420"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M418.643 227.849c-4.323-1.011-8.767.424-12.899 1.989-21.043 7.971-40.418 19.729-60.726 29.394a338.184 338.184 0 01-159.785 32.542c-10.054-.441-20.187-1.358-29.861-4.055a5.969 5.969 0 01-.225 1.798c-1.081 3.778-5.697 5.343-9.614 5.118-3.916-.224-7.781-1.642-11.68-1.314-3.899.329-8.1 3.458-7.512 7.323a7.778 7.778 0 002.316 4.072c5.188 5.412 13.116 6.985 20.516 8.291l45.449 8.006c8.187 1.443 18.268 4.841 19.02 13.115a10.462 10.462 0 01-1.288 5.879c25.193-2.283 50.265-6.804 74.973-11.879 38.343-7.876 73.901-20.395 106.832-40.893a282.892 282.892 0 0013.167-8.732c7.366-5.187 14.697-10.928 19.21-18.717 4.513-7.79 5.697-18.156.718-25.643a14.7 14.7 0 00-8.611-6.294z"
                fill="#FF3E2F"
                stroke="#FF3E2F"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></path>
            <path
                d="M145.767 95.738c3.804 1.072 2.862 6.916.251 9.882-2.611 2.965-6.363 5.965-5.723 9.856a5.98 5.98 0 003.821 4.383c58.08-37.608 145.001-48.363 192.836-40.634 1.306.208 2.594.441 3.865.683a8.264 8.264 0 011.504-7.046c1.816-2.135 4.954-3.233 5.801-5.887 1.314-4.115-3.743-7.193-7.841-8.542l-34.867-11.55c-4.418-1.461-8.983-3.009-12.441-6.13a3.548 3.548 0 01-1.375-2.248 3.634 3.634 0 011.263-2.507 28.584 28.584 0 013.562-3.242c-47.836 4.323-95.022 16.219-138.526 36.484-19.167 8.922-37.755 19.616-54.467 32.498-.743 1.591-1.115 3.363-.224 4.798 1.556 2.525 5.36 1.824 8.144.804l30.302-11.049c1.297-.45 2.749-.942 4.115-.553z"
                fill="#F9A725"
                stroke="#F9A725"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></path>
            <path
                d="M393.943 197.511c-3.389-3.207-8.757-2.663-13.322-1.729a160.587 160.587 0 00-32.222 10.452c-3.25 1.453-6.639 3.044-10.184 2.767-3.545-.277-7.158-3.259-6.674-6.787.484-3.527 4.573-6.121 3.83-9.51-.45-2.066-2.594-3.371-4.729-3.562a9.72 9.72 0 00-2.067.061c-18.881 12.968-44.619 24.207-64.841 28.737-24.207 5.43-68.463 12.251-83.791-1.175a37.849 37.849 0 01-11.04-15.45c-2.594 1.859-6.657 2.162-8.819-.216-1.409-1.539-1.729-3.769-1.815-5.853-.796-16.003 6.181-31.279 13.417-45.579a2.826 2.826 0 00.433-2.135 3.38 3.38 0 00-1.219-1.306 9.28 9.28 0 01-3.035-4.564 226.973 226.973 0 00-15.069 12.968 64.16 64.16 0 00-20.68 41.913c-1.184 15.259 4.591 30.734 16.902 39.829 12.311 9.095 27.838 12.571 43.011 14.559 64.841 8.525 132.518-6.968 187.191-42.829 5.006-3.285 9.943-6.787 14.698-10.513l.025-.078z"
                fill="#00E4B3"
                stroke="#00E4B3"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></path>
            <path
                d="M259.662 193.354a201.764 201.764 0 0032.853-7.868 7.736 7.736 0 00-4.816-1.219c-2.593.165-5.057 1.228-7.599 1.816a20.89 20.89 0 01-9.614-.069c-1.643-.407-3.458-1.202-3.899-2.758-.674-2.257 1.841-4.167 4.115-5.066 5.888-2.309 4.963-4.444 4.063-6.847l-.458.146c-13.564 4.055-39.838 6.657-45.578.986-5.741-5.671-4.323-11.714-.934-15.562 5.879-6.743 14.377-10.469 23.939-12.164 9.562-1.694 11.421 1.876 10.919 3.917-.501 2.04-3.631 8.766-5.662 9.293 6.051-.129 15.138-3.985 18.051-9.293 2.914-5.309 1.159-11.758-11.801-12.26-17.291-.674-36.233 5.473-48.267 17.87-7.262 7.47-15.467 20.533-7.34 31.989 7.582 10.789 30.086 10.426 52.028 7.089z"
                fill="#202F9E"
                stroke="#202F9E"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></path>
            <path
                d="M194.622 321.046l-45.449-8.032c-7.401-1.305-15.311-2.879-20.516-8.291a7.786 7.786 0 01-2.317-4.072c-.587-3.873 3.606-6.985 7.513-7.323 3.908-.337 7.781 1.081 11.68 1.315 3.899.233 8.533-1.341 9.614-5.119.166-.584.242-1.19.225-1.798a70.368 70.368 0 01-3.709-1.132c-18.484-6.156-34.167-19.591-44.472-36.13-15.813-25.391-23.161-60.215-7.677-87.059 8.005-13.885 19.832-25.193 32.498-35.014 3.864-3 7.91-5.845 12.103-8.559a5.976 5.976 0 01-3.821-4.384c-.64-3.89 3.113-6.916 5.723-9.855 2.611-2.94 3.554-8.81-.25-9.882-1.366-.39-2.819.104-4.159.588l-30.302 11.049c-2.784 1.02-6.588 1.729-8.144-.804-.865-1.436-.519-3.208.225-4.799a197.26 197.26 0 00-39.173 39.467c-23.55 32.074-35.533 74.039-25.841 112.641 8.93 35.542 36.492 65.844 71.04 78.095a155.314 155.314 0 0030.812 7.08c1.435.199 2.87.381 4.323.553 22.599 2.741 45.241 2.482 67.789.433a10.468 10.468 0 001.288-5.879c-.735-8.248-10.816-11.611-19.003-13.089z"
                fill="#F87D21"
                stroke="#F87D21"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></path>
            <path
                d="M432.25 149.781A85.52 85.52 0 00386.698 39.82c-19.444-8.404-41.257-9.311-62.429-8.646-9.291.277-18.573.854-27.847 1.73a28.639 28.639 0 00-3.562 3.242 3.643 3.643 0 00-1.262 2.507 3.542 3.542 0 001.374 2.248c3.459 3.12 8.023 4.668 12.441 6.13l34.867 11.55c4.098 1.348 9.156 4.426 7.842 8.541-.865 2.654-3.986 3.752-5.802 5.888a8.275 8.275 0 00-1.504 7.046c19.297 3.778 33.942 12.103 37.444 34.919 3.734 24.337-24.121 53.368-39.389 66.483a121.356 121.356 0 01-10.297 7.85 9.713 9.713 0 012.066-.06c2.101.19 4.323 1.495 4.73 3.562.743 3.458-3.355 6.051-3.83 9.51-.476 3.458 3.129 6.51 6.674 6.786 3.545.277 6.916-1.314 10.184-2.766a160.527 160.527 0 0132.222-10.453c4.565-.959 9.933-1.504 13.322 1.73 16.435-12.96 30.692-28.608 38.308-47.836z"
                fill="#FFBE00"
                stroke="#FFBE00"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></path>
            <path
                d="M158.312 195.237c.104 2.084.406 4.323 1.816 5.853 2.161 2.378 6.181 2.075 8.818.216-3.389-9.172-2.196-18.544.441-26.8 4.158-13.038 13.738-23.749 24.622-32.04a112.394 112.394 0 0175.146-22.479c10.02.709 21.259 4.029 27.51 11.17 2.144-4.668-2.715-11.585 1.34-14.766 1.245-.977 2.931-1.124 4.513-1.15a48.768 48.768 0 0125.279 6.614c.995.579 1.989 1.193 3.018 1.729a31.128 31.128 0 00-11.784-14.092c-7.167-4.504-15.882-5.749-24.337-6.147-49.927-2.352-89.636 9.138-126.785 38.308a9.286 9.286 0 003.034 4.565c.516.318.937.769 1.219 1.305a2.826 2.826 0 01-.432 2.136c-7.236 14.299-14.213 29.576-13.418 45.578z"
                fill="#2CC298"
                stroke="#2CC298"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></path>
            <path
                d="M330.813 123.584c-1.029-.501-2.023-1.115-3.017-1.729a48.768 48.768 0 00-25.279-6.614c-1.582 0-3.268.173-4.513 1.15-4.055 3.182.804 10.098-1.34 14.767a19.1 19.1 0 014.323 8.282c1.78 7.47-1.401 15.51-6.761 21.017s-12.303 8.645-19.504 10.85c.864 2.403 1.824 4.539-4.064 6.847-2.274.865-4.789 2.81-4.115 5.066.467 1.557 2.256 2.352 3.899 2.758 3.156.771 6.447.795 9.614.07 2.542-.588 4.988-1.652 7.599-1.816a7.73 7.73 0 014.816 1.219 90.45 90.45 0 0014.498-6.19c12.432-6.917 22.833-18.415 26.04-32.282a38.039 38.039 0 00-2.196-23.395z"
                fill="#008DDC"
                stroke="#008DDC"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></path>
            <path
                d="M385.34 188.427h1.772M375.312 156.534l.588.596M407.768 158.921h.587M396 127.615l1.176 1.185M407.18 83.395h1.184M378.26 82.797v.597M248.682 110.828v.596M373.539 62.74h.588M336.951 48.57l.588.597M273.805 57.976l1.184.596M254.924 71.758l1.184.588M221.215 62.067l1.202-1.15M168.771 78.664l1.176.596M159.375 91.763c.553-.208 1.046.743.553 1.072M110.959 122.931h1.184M77.303 144.761v.597M59.598 169.546h.587M77.303 212.628h1.175M67.266 280.484v1.185M56.053 259.83h1.184M100.904 285.8h1.729M155.787 328.285l-.588-1.176M174.643 307.596l1.262-1.081M198.867 318.845l.588-.588M232.498 305.235l1.184.597M280.299 316.475l1.184-.588M297.416 295.242l.588.588M351.139 293.425l1.824 1.09M339.312 279.897l.588-.588M382.426 257.469h.588M411.898 254.521h1.176M349.34 196.691h.596M323.967 214.391a.863.863 0 00-.536 1.158M302.137 216.187h1.175M254.336 240.395l1.176-.588M196.549 237.412h.588M207.461 122.931h.588M197.527 131.185h.588M169.359 228.543a2.073 2.073 0 001.729-1.168M146.346 213.803l.588.597M152.838 189.613h.588M277.938 111.128h1.184M307.445 130.597l.588.588M323.379 138.865h1.729M299.732 172.476l1.09-1.833M254.033 186.871l.605-1.176M213.624 173.679a.913.913 0 00.597 1.141M224.828 179.012h1.185M267.908 144.758l.588-1.176"
                stroke="#323130"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></path>
            <path
                d="M251.103 166.535c6.236 0 11.291-5.055 11.291-11.291 0-6.236-5.055-11.291-11.291-11.291-6.235 0-11.291 5.055-11.291 11.291 0 6.236 5.056 11.291 11.291 11.291z"
                fill="#fff"
                stroke="#323130"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></path>
            <path
                d="M44.358 133.621a.925.925 0 10-.033-1.85l.016.925-.016-.925-.125.002-.34.007c-.29.006-.692.016-1.146.028-.904.024-2.025.061-2.86.109a.926.926 0 00.109 1.848c.803-.047 1.899-.083 2.801-.107.45-.012.848-.021 1.135-.027l.337-.007.122-.003zM13.51 132.293a.925.925 0 011.036.799l.293 2.267a.926.926 0 01-1.836.238l-.293-2.268a.926.926 0 01.8-1.036zM11.927 134.264a.926.926 0 00-1.836.238l.188 1.447a.925.925 0 101.836-.239l-.188-1.446zM9.277 135.158a.926.926 0 00-1.835.238l.117.904a.926.926 0 001.835-.238l-.117-.904z"
                fill="#323130"
            ></path>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M44.493 210.518c-1.84 0-3.393 1.417-3.393 3.239 0 1.821 1.553 3.239 3.393 3.239 1.84 0 3.393-1.418 3.393-3.239 0-1.822-1.553-3.239-3.393-3.239zm-2.16 3.239c0-1.075.934-2.005 2.16-2.005s2.16.93 2.16 2.005c0 1.074-.934 2.005-2.16 2.005s-2.16-.931-2.16-2.005z"
                fill="#323130"
            ></path>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M46.92 127.148c.716.245 1.4.547 1.909.925l.001.001c1.925 1.435 3.378 4.262 4.446 7.138 1.086 2.928 1.845 6.116 2.28 8.488 1.243 6.679 2.634 13.328 4.032 19.987l.173.826c1.341 6.381 2.684 12.773 3.901 19.191l.305 1.599.01.054c.978 5.118 1.983 10.373 2.45 15.599.05.563.112 1.159.178 1.779.262 2.497.565 5.381.28 8.003-.364 3.338-1.704 6.497-5.4 8.091-3.38 1.458-11.016 4.291-13.669 5.002-7.227 1.937-15.761 3.757-23.682 2.885-3.65-.405-6.55-2.911-8.295-5.577l-.004-.006a16.426 16.426 0 01-2.17-5.116l-.002-.007c-.153-.676-.368-1.683-.622-2.936 0-.006-.002-.011-.003-.017l-4.297-23.409v-.007c-.794-4.512-1.522-8.697-2.051-11.739l-.002-.008-.443-2.548c-2.628-15.072-4.582-29.626-5.203-37.474-.17-2.119.18-3.85.984-5.246.803-1.396 2.011-2.372 3.41-3.067 2.743-1.364 6.4-1.725 9.69-2.013h.002c1.27-.11 2.506-.219 3.721-.327 7.136-.632 13.497-1.195 21.032-1.219 1.225-.003 2.992.185 4.651.521.834.169 1.659.378 2.388.627zm-7.033.703c1.073-.003 2.712.167 4.278.484.78.158 1.524.348 2.157.565.647.221 1.12.449 1.403.659 1.456 1.086 2.758 3.447 3.816 6.297 1.038 2.799 1.773 5.877 2.196 8.18v.002c1.247 6.703 2.642 13.372 4.04 20.03l.172.819c1.342 6.386 2.681 12.762 3.895 19.162l.314 1.649c.98 5.132 1.967 10.295 2.425 15.423v.001c.056.622.122 1.26.19 1.908v.002c.26 2.482.534 5.102.272 7.506-.323 2.968-1.438 5.361-4.293 6.592-3.344 1.442-10.886 4.235-13.415 4.913-7.202 1.931-15.448 3.664-23 2.833-2.913-.323-5.385-2.362-6.947-4.747a14.58 14.58 0 01-1.923-4.532c-.149-.655-.359-1.643-.61-2.882l-4.294-23.394v-.004c-.793-4.509-1.52-8.69-2.05-11.731l-.002-.012-.443-2.546c-2.623-15.045-4.567-29.536-5.18-37.302v-.002c-.149-1.833.164-3.171.742-4.175s1.47-1.757 2.63-2.333c2.372-1.18 5.656-1.531 9.027-1.826 1.277-.11 2.52-.22 3.736-.328 7.136-.632 13.414-1.188 20.864-1.211z"
                fill="#323130"
            ></path>
            <path
                d="M61.485 218.829c3.696-1.594 5.037-4.753 5.4-8.091.285-2.622-.018-5.506-.28-8.003-.066-.62-.128-1.216-.179-1.779-.466-5.226-1.47-10.481-2.449-15.599l-.01-.054-.305-1.599c-1.217-6.418-2.56-12.81-3.9-19.191l-.174-.826c-1.398-6.659-2.789-13.308-4.031-19.987-.436-2.372-1.195-5.56-2.281-8.488-1.068-2.876-2.521-5.703-4.446-7.138l-.001-.001c-.51-.378-1.193-.68-1.909-.925a19.598 19.598 0 00-2.388-.627c-1.66-.336-3.426-.524-4.651-.521-7.535.024-13.896.587-21.032 1.219-1.215.108-2.452.217-3.721.327h-.002c-3.29.288-6.947.649-9.69 2.013-1.399.695-2.607 1.671-3.41 3.067-.804 1.396-1.155 3.127-.984 5.246.62 7.848 2.575 22.402 5.203 37.474l.443 2.548.002.008c.529 3.042 1.257 7.227 2.05 11.739l.001.007 4.297 23.409.003.017c.254 1.253.469 2.26.622 2.936l.002.007a16.426 16.426 0 002.17 5.116l.004.006c1.745 2.666 4.646 5.172 8.295 5.577h0c7.92.872 16.455-.948 23.682-2.885 2.653-.711 10.288-3.544 13.669-5.002zm0 0l-.367-.849m-16.793-86.209a.925.925 0 01.033 1.85l-.122.003-.337.007c-.287.006-.685.015-1.135.027-.902.024-1.998.06-2.801.107a.926.926 0 01-.108-1.848 102.42 102.42 0 012.86-.109c.453-.012.855-.022 1.144-.028l.341-.007.125-.002zm0 0l.016.925-.016-.925zm-.16-3.436c-1.566-.317-3.205-.487-4.278-.484-7.45.023-13.728.579-20.864 1.211-1.217.108-2.459.218-3.736.328-3.371.295-6.655.646-9.027 1.826-1.16.576-2.052 1.329-2.63 2.333-.578 1.004-.89 2.342-.743 4.175v.002c.614 7.766 2.558 22.257 5.18 37.302l.444 2.546.002.012a6465.99 6465.99 0 002.05 11.731v.004l4.294 23.394c.251 1.239.462 2.227.61 2.882a14.58 14.58 0 001.923 4.532c1.562 2.385 4.034 4.424 6.948 4.747 7.551.831 15.797-.903 23-2.833 2.528-.678 10.07-3.471 13.414-4.913 2.855-1.231 3.97-3.624 4.293-6.592.262-2.404-.012-5.024-.272-7.506v-.002c-.068-.648-.134-1.286-.19-1.908v-.001c-.458-5.128-1.444-10.291-2.425-15.423l-.314-1.649c-1.214-6.4-2.553-12.776-3.895-19.162l-.172-.819c-1.398-6.658-2.793-13.327-4.04-20.03v-.002c-.423-2.303-1.158-5.381-2.197-8.18-1.057-2.85-2.36-5.211-3.815-6.297-.282-.21-.756-.438-1.403-.659a17.576 17.576 0 00-2.157-.565zm-29.62 4.757a.925.925 0 10-1.835.237l.293 2.268a.926.926 0 001.836-.238l-.293-2.267zm-3.655.373a.926.926 0 011.037.799l.188 1.446a.925.925 0 11-1.836.239l-.188-1.447a.926.926 0 01.799-1.037zm-2.65.894a.926.926 0 011.037.799l.117.904a.926.926 0 01-1.835.238l-.117-.904a.926.926 0 01.798-1.037zm36.253 77.393c-1.226 0-2.16.93-2.16 2.005 0 1.074.934 2.005 2.16 2.005s2.16-.931 2.16-2.005c0-1.075-.934-2.005-2.16-2.005zm-3.393 2.005c0-1.822 1.553-3.239 3.393-3.239 1.84 0 3.393 1.417 3.393 3.239 0 1.821-1.553 3.239-3.393 3.239-1.84 0-3.393-1.418-3.393-3.239z"
                stroke="#000"
            ></path>
            <path
                d="M87.377 355.953l-1.2 14.686a26.776 26.776 0 000 6.628 8.979 8.979 0 003.129 5.69c1.71 1.277 3.933 1.692 6.06 2.043 2.47.409 4.974.818 7.464.543 2.49-.274 4.994-1.328 6.488-3.34 1.59-2.132 1.807-4.967 1.915-7.63.039-1.239-.159-19.559-.6-19.463-.013.013-19.08.53-23.256.843z"
                stroke="#323130"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></path>
            <path
                d="M88.936 355.865c-2.21-9.106-13.065-11.922-18.346-18.518-6.008-7.529-6.277-18.576-4.916-24.348 2.637-11.226 14.226-18.576 25.695-19.795 9.335-.971 19.195 1.519 26.27 7.662 7.075 6.143 10.913 16.188 8.767 25.319-1.347 5.747-4.859 10.798-9.074 14.929-3.754 3.678-8.435 8.742-8.908 13.984"
                stroke="#323130"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></path>
            <path
                d="M93.113 349.07a63.395 63.395 0 00-5.62-22.068c-1.705-3.716-3.978-7.465-7.662-9.259a3 3 0 00-2.408-.313 2.622 2.622 0 00-1.309 1.526c-.945 2.414.109 5.313 2.101 6.973 1.992 1.661 4.72 2.223 7.305 2.044 7.471-.511 13.92-7.439 13.908-14.923a4.125 4.125 0 00-.486-2.203c-1.04-1.603-3.735-1.22-4.872.319-1.136 1.539-1.085 3.646-.702 5.517.926 4.559 3.646 8.863 7.739 11.066 4.093 2.203 9.579 1.98 13.071-1.066a5.353 5.353 0 002.044-3.525c.153-2.286-2.088-4.253-4.374-4.31-2.286-.058-4.4 1.424-5.664 3.333-1.265 1.909-1.814 4.189-2.216 6.437a78.367 78.367 0 00-.862 19.795M92.174 365.977c5.133-.295 10.249-.854 15.325-1.673M89.894 374.557s12.772-2.044 16.392-2.669l1.513-.262M486.711 97.963H374.422a2.422 2.422 0 00-2.422 2.422v6.071a2.421 2.421 0 002.422 2.421h112.289a2.421 2.421 0 002.422-2.421v-6.071a2.422 2.422 0 00-2.422-2.422zM412.432 108.322a33.083 33.083 0 01.655-10.359"
                stroke="#323130"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></path>
            <path
                d="M422.504 97.963s16.005-35.913 24.619-53.212c.985-1.97 2.02-4.006 3.748-5.371a10.937 10.937 0 013.528-1.74c3.219-1.012 6.632-1.205 10.006-1.343a351.307 351.307 0 0146.975 1.211c2.257.21 5.036.87 5.548 3.088.281 1.227-.303 2.466-.864 3.594-8.806 17.58-19.264 36.65-27.745 54.39M482.082 39.864h1.712M482.067 103.482h-3.622M474.057 103.482h-3.627M466.045 103.482h-3.627M184.147 73.035C197.404 55.27 211.814 36.265 226 19.273c-.069-3.632-.72-8.381-1.061-11.996a437.272 437.272 0 00-35.507-4.841c-12.877-1.222-23.967-.289-34.169 8.237A324.007 324.007 0 00116.407 49.2a19.965 19.965 0 00-3.459 5.06c-1.326 3.171-.985 6.762-.617 10.18.318 2.975 4.243 5.223 7.102 6.11a371.21 371.21 0 0055.001 12.595 3.5 3.5 0 001.603 0 3.465 3.465 0 001.614-1.58c1.879-2.916 4.432-5.758 6.496-8.53z"
                stroke="#323130"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></path>
            <path
                d="M224.161 8.711a874.991 874.991 0 00-48.811 59.152 4.724 4.724 0 01-4.709 1.833l-49.946-12.019c-1.62-.386-3.292-.778-4.934-.507-1.643.271-3.263 1.372-3.609 2.997M173.967 82.18c-.34-3.338-.576-12.163-.576-12.163M171.178 17.251c4.611-.305 14.56 1.81 19.079 2.767M172.336 22.826c2.68-.156 11.759 1.302 11.759 1.302M173.967 77.553c9.401-14.076 19.984-26.941 30.55-40.17M214.361 27.541a274.472 274.472 0 018.543-10.485"
                stroke="#323130"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></path>
            <path
                d="M115.928 62.869c5.528-1.839 11.528-.133 17.113 1.574 2.514.766 20.97 5.36 20.97 5.36M126.016 67.556c14.151 3.268 33.639 7.689 47.98 9.995M480.787 248.499a193.133 193.133 0 009.608 10.402c1.881 1.897 3.836 3.777 6.164 5.182.575.348 1.319.676 1.824.391a1.14 1.14 0 00.477-.706c.806-2.692.008-6.165-.567-8.642 1.838-5.224 4.569-12.179 6.402-17.39l.956-2.804c.258-.758.406-1.792-.396-2.327-.601-.401-1.357-.239-1.97-.04-4.052 1.31-10.856 6.396-13.789 9.11-5.383-4.692-15.527-12.267-32.24-19.767s-32.729-13.772-49.202-16.306c-7.201-1.106-16.326-1.186-17.853 3.291-1.526 4.477 8.434 10.212 13.849 12.466 10.936 4.563 24.557 9.971 36.898 14.975"
                stroke="#323130"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></path>
            <path
                d="M470.777 276.378c.166 1.418.194 3.079-1.609 3.384a3.43 3.43 0 01-1.567-.161 3.883 3.883 0 01-1.406-.847c-5.07-4.616-8.792-10.216-12.372-15.784a729.345 729.345 0 01-16.134-26.252c-.55-.934-1.398-2.641-2.003-3.87a.685.685 0 01-.069-.392.56.56 0 01.168-.331.64.64 0 01.352-.163.846.846 0 01.424.056l26.163 10.418c.48.192.919.489 1.271.864.353.374.608.813.741 1.272 2.821 9.694 5.001 22.391 6.041 31.806zM462.672 221.971c-1.01-7.841-.95-16.503-1.734-24.472-.131-1.322-.451-2.882-1.731-3.637a3.367 3.367 0 00-1.477-.376 2.644 2.644 0 00-1.363.335 6.427 6.427 0 00-1.914 1.824c-3.887 4.849-8.225 12.165-10.972 17.74M466.411 248.453l18.685 6.955M415.029 211.643l-2.473-.855M471.857 234.132c-15.004-6.79-33.43-13.997-53.348-21.287M496.454 254.071c-5.383-2.86-11.771-4.637-17.155-6.12"
                stroke="#323130"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></path>
            <path
                d="M443.32 210.472c-1.456-.606-2.152-2.558-1.553-4.36.598-1.803 2.263-2.772 3.719-2.166 1.457.606 2.152 2.558 1.554 4.36-.598 1.802-2.264 2.772-3.72 2.166zM441.963 254.488c-1.456-.606-2.152-2.558-1.554-4.36.598-1.802 2.264-2.772 3.72-2.166 1.456.606 2.152 2.558 1.554 4.36-.599 1.802-2.264 2.772-3.72 2.166z"
                stroke="#323130"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></path>
            <path
                d="M380.024 326.409c-.743-13.08-4.158-27.665-11.239-45.596-3.458-8.697-8.438-19.72-14.057-27.345-5.62-7.626-13.262-14.179-22.807-16.366.363-4.271.726-8.594 0-12.83-.726-4.236-2.594-8.438-6.052-11.239-2.68-2.162-6.051-3.32-9.432-4.323-4.66-1.444-9.51-2.905-14.446-2.689a57.388 57.388 0 002.005 11.239 101.962 101.962 0 00-6.743 20.689c-6.622 2.326-11.749 7.556-15.138 13.418-3.389 5.861-5.239 12.389-7.055 18.838l-13.599 48.423a150.493 150.493 0 00-4.418 18.571 8.263 8.263 0 004.66 8.299 17.708 17.708 0 008.533 1.098 3.926 3.926 0 004.271-3.458c1.729-5.637 3.786-13.106 5.758-18.665 1.063-3.009 7.781-20.75 9.259-25.072.32 38.671 2.369 92.835 1.547 106.149 0 0-8.308 7.469-10.806 11.481h81.198c-2.594-3.761-6.389-8.326-9.839-11.092-.13-17.646-.908-42.735-1.02-47.974-.484-22.176-1.418-45.233-2.326-67.703 7.427 12.908 14.326 29.066 16.876 43.582a3.786 3.786 0 004.237 2.974 20.203 20.203 0 006.916-2.101 7.22 7.22 0 002.861-2.299c.951-1.548.951-4.28.856-6.009z"
                fill="#fff"
            ></path>
            <path
                d="M348.287 290.159c7.426 12.907 14.326 29.066 16.876 43.581a3.786 3.786 0 004.236 2.974 20.201 20.201 0 006.917-2.101 7.282 7.282 0 002.861-2.299c.942-1.444.942-4.185.865-5.888-.744-13.08-4.159-27.665-11.239-45.596-3.459-8.697-8.438-19.72-14.058-27.345-5.619-7.626-13.262-14.179-22.807-16.366.364-4.271.727-8.594 0-12.83-.726-4.236-2.593-8.438-6.051-11.239-2.68-2.161-6.052-3.32-9.433-4.323-4.659-1.444-9.51-2.905-14.446-2.689a57.487 57.487 0 002.006 11.24 101.874 101.874 0 00-6.744 20.688c-6.622 2.326-11.749 7.556-15.138 13.418-3.389 5.861-5.239 12.389-7.055 18.838l-13.616 48.406a150.478 150.478 0 00-4.418 18.57 8.261 8.261 0 004.66 8.3 17.708 17.708 0 008.533 1.098 3.926 3.926 0 004.271-3.458c1.729-5.637 3.786-13.107 5.758-18.666 1.063-3.008 7.781-20.749 9.259-25.071"
                stroke="#323130"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></path>
            <path
                d="M289.54 280.682c-.501 37.037 2.49 109.114 1.53 124.762 0 0-8.308 7.47-10.806 11.482h81.198c-2.594-3.761-6.389-8.326-9.839-11.093-.13-17.645-.908-42.734-1.02-47.973-.579-26.749-1.833-54.795-2.879-81.535M269.302 336.576c-1.349 3.26-1.124 5.585-1.124 9.087M263.398 334.188a38.775 38.775 0 00-1.253 9.83M369.623 325.381a40.202 40.202 0 011.383 10.781M374.344 323.736a51.483 51.483 0 011.919 10.115M317.648 318.973l7.972-.995M321.625 318.748v97.054M312.564 217.951l1.315-1.064M301.973 223.527a4.955 4.955 0 005.507.7"
                stroke="#323130"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            ></path>
            <path
                d="M252 418.031a1 1 0 011-1h131a1 1 0 010 2H253a1 1 0 01-1-1z"
                fill="#323130"
            ></path>
        </svg>
    );
}
